/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { IDODOHelper, IDODOHelperInterface } from "../IDODOHelper";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IDODO",
        name: "dodo",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "querySellQuoteToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class IDODOHelper__factory {
  static readonly abi = _abi;
  static createInterface(): IDODOHelperInterface {
    return new utils.Interface(_abi) as IDODOHelperInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IDODOHelper {
    return new Contract(address, _abi, signerOrProvider) as IDODOHelper;
  }
}
